<template>
  <div>
    <highcharts
      :options="chartOptions"
      ref="lineCharts"
    ></highcharts>
  </div>
</template>

<script>
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import exportingInit from "highcharts/modules/exporting";
import exportDataInit from "highcharts/modules/export-data";
import accessibilityInit from "highcharts/modules/accessibility";


exportingInit(Highcharts);
exportDataInit(Highcharts);
accessibilityInit(Highcharts);

export default {
  props: {
    xAxisCategories: {
      type: Array
    },
    yAxisTitle: {
      type: String
    },
    series: {
      type: Array
    },
    chartTitle:{
      type: String
    }
  },

  components: {
    highcharts: Chart
  },

  created() {      
      this.chartOptions.series = this.series;
      this.chartOptions.title.text = this.chartTitle;
  },

  data() {
    return {
      chartOptions: {
        title: {
          text: ''
        },
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y:.1f} TRY</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },                      
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.percentage:.1f} %'
            }
          }
        },
        series: []
      }
    };
  }
};
</script>
